import GetBusinessUnitByIdRequestModelBase from '../_generated/modelBases/get-business-unit-by-id-request-model-base';

export default class GetBusinessUnitByIdRequestModel extends GetBusinessUnitByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
